import type { MenuItemUpdateByItemRequest } from '~/services/api/generated'

const flag = (value: boolean): string => (value ? '1' : '0')
const text = (value: string | number | null): string => String(value ?? '')
const same = (value: Blob): Blob => value

const append = <Value>(
  formData: FormData,
  name: string,
  value: Value | undefined,
  encode: (value: Value) => string | Blob
): void => {
  if (value !== undefined) formData.append(name, encode(value))
}

/** Serializes an item update request to the multipart wire form, omitting absent fields. */
export const buildMenuItemUpdateFormData = (
  request: Omit<MenuItemUpdateByItemRequest, 'photo'> & { readonly photo?: File | undefined }
): FormData => {
  const formData = new FormData()
  for (const groupId of request.customization_group_ids ?? []) {
    formData.append('customization_group_ids[]', String(groupId))
  }
  for (const [index, group] of (request.customization_groups ?? []).entries()) {
    formData.append(`customization_groups[${index}][id]`, String(group.id))
    append(formData, `customization_groups[${index}][sort_order]`, group.sort_order, String)
  }
  append(formData, 'default_price', request.default_price, String)
  append(formData, 'description', request.description, text)
  for (const attributeId of request.dietary_attribute_ids ?? []) {
    formData.append('dietary_attribute_ids[]', String(attributeId))
  }
  append(formData, 'individual_packaging_available', request.individual_packaging_available, flag)
  append(formData, 'is_available', request.is_available, flag)
  append(formData, 'is_featured', request.is_featured, flag)
  append(formData, 'is_package', request.is_package, flag)
  append(formData, 'menu_category_id', request.menu_category_id, String)
  append(formData, 'minimum_guest_count', request.minimum_guest_count, text)
  append(formData, 'name', request.name, String)
  append(formData, 'out_of_stock', request.out_of_stock, flag)
  append(formData, 'photo', request.photo, same)
  append(formData, 'price_type', request.price_type, String)
  append(formData, 'serves_count', request.serves_count, text)
  append(formData, 'sort_order', request.sort_order, String)
  append(formData, 'status', request.status, String)
  append(formData, 'tax_category', request.tax_category, String)
  append(formData, 'weight_unit', request.weight_unit, text)
  append(formData, 'weight_value', request.weight_value, text)
  return formData
}
